import { render, staticRenderFns } from "./vitransfer.vue?vue&type=template&id=3b3719d6&scoped=true"
import script from "./vitransfer.vue?vue&type=script&lang=js"
export * from "./vitransfer.vue?vue&type=script&lang=js"
import style0 from "./vitransfer.vue?vue&type=style&index=0&id=3b3719d6&prod&lang=css"
import style1 from "./vitransfer.vue?vue&type=style&index=1&id=3b3719d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3719d6",
  null
  
)

export default component.exports